import { Helmet } from "react-helmet";
import AboutUsLayout from "../sections/aboutUs/aboutUsLayout";

const AboutUsPage = () => {
    <Helmet>
        <title>About us</title>
        <meta name="description" content="Discover Edliena – the home of Learn with Cuddles! We create fun, safe, and playful learning games that help kids explore numbers and early math with joy. Learning made easy, happy, and full of giggles!" />
        <meta name="keywords" content="About Edliena, Learn with Cuddles story, kids learning games, fun math for children, early learning creators, safe educational games, playful learning, preschool math adventure" />
        <link rel="canonical" href="https://cuddles.edliena.com/about-us" />
    </Helmet>

    return (
        <>
            <AboutUsLayout />
        </>
    );
}

export default AboutUsPage;